import {
  UPDATE_SCHOOLCLASS,
  ADD_SCHOOLCLASS_VIDEO,
  REMOVE_SCHOOLCLASS_VIDEO,
  ADD_SCHOOLCLASS_PHOTO,
  REMOVE_SCHOOLCLASS_PHOTO,
  UPDATE_PROJECT,
  SET_TIMER,
  SET_GROUP_ID,
} from '../actions/types';

const initialState = {
  className: '',
  classRoom: '',
  Groups: [],
  SchoolClassVideos: [],
  SchoolClassPhotos: [],
  loaded: false,
};

const schoolClass = (state = initialState, action) => {
  const { payload, type } = action;
  switch (type) {
    case UPDATE_PROJECT:
      state = {
        ...state,
        ...payload.schoolClass,
      };
      break;
    case UPDATE_SCHOOLCLASS:
      state = {
        ...state,
        ...payload,
      };
      break;
    case ADD_SCHOOLCLASS_VIDEO:
      if (payload.id) {
        state.SchoolClassVideos.push(payload);
      }
      break;
    case REMOVE_SCHOOLCLASS_VIDEO:
      if (payload.id) {
        const i = state.SchoolClassVideos.findIndex(scv => scv.id === payload.id);
        state.SchoolClassVideos.splice(i, 1);
      }
      break;
    case ADD_SCHOOLCLASS_PHOTO:
      if (payload.id) {
        state.SchoolClassPhotos.push(payload);
      }
      break;
    case REMOVE_SCHOOLCLASS_PHOTO:
      if (payload.id) {
        const i = state.SchoolClassPhotos.findIndex(scp => scp.id === payload.id);
        state.SchoolClassPhotos.splice(i, 1);
      }
      break;
    case SET_TIMER:
      const { timerEndsAt, timerPausedAt } = payload;
      if (timerEndsAt || timerEndsAt === null) state.timerEndsAt = timerEndsAt;
      if (timerPausedAt || timerPausedAt === null) state.timerPausedAt = timerPausedAt;
      break;
    case SET_GROUP_ID:
      state.groupId = parseInt(payload, 10);
      break;
    default:
      return state;
  }
  const group = state.Groups.find(g => g.id === state.groupId);
  state.group = group ? {
    ...group,
    loaded: true,
  } : undefined;
  return {...state};
};

export default schoolClass;



// WEBPACK FOOTER //
// ./src/reducers/schoolClass.js